export default {
  firstName: "first name",
  lastName: "last name",
  birth: "date of birth",
  email: "email",
  phone: "mobile number",
  password: "password",
  homeAddress: "home auto address",
  homeStreet: "street address",
  homeDetails: "street address second line",
  homeCity: "city",
  homeState: "state",
  homeZip: "zip code",
  mailingSelect: "my mailing address on",
  mailingUnselect: "my mailing address off",
  mailingStreet: "mailing address",
  mailingDetails: "mailing address second line",
  mailingCity: "mailing address city",
  mailingState: "mailing address state",
  mailingZip: "mailing address zip code",
  ssn: "ssn - 4 digits",
  promoCodeInput: "promo code",
  fullSsn: "ssn - full",
  channelSelected: "tvg channel provider on",
  channelUnselected: "tvg channel provider off",
  cableSelected: "Cable Provider"
};
